var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 24.5827H13.3334V15.416H19.8334L19.1667 16.0827C19.0001 16.2493 18.9167 16.416 18.9167 16.666C18.9167 17.166 19.2501 17.4993 19.7501 17.4993C20.0001 17.4993 20.1667 17.416 20.3334 17.2493L22.4167 15.166C22.7501 14.8327 22.7501 14.3327 22.4167 13.9993L20.3334 11.916C20.0001 11.5827 19.5001 11.5827 19.1667 11.916C18.8334 12.2493 18.8334 12.7493 19.1667 13.0827L19.8334 13.7493H12.5001C12.0001 13.7493 11.6667 14.0827 11.6667 14.5827V25.416C11.6667 25.916 12.0001 26.2493 12.5001 26.2493H14.5834C15.0834 26.2493 15.4167 25.916 15.4167 25.416C15.4167 24.916 15.0834 24.5827 14.5834 24.5827ZM27.5001 13.7493H25.4167C24.9167 13.7493 24.5834 14.0827 24.5834 14.5827C24.5834 15.0827 24.9167 15.416 25.4167 15.416H26.6667V24.5827H19.6667L20.3334 23.916C20.6667 23.5827 20.6667 23.0827 20.3334 22.7493C20.0001 22.416 19.5001 22.416 19.1667 22.7493L17.0834 24.8327C16.7501 25.166 16.7501 25.666 17.0834 25.9994L19.1667 28.0827C19.3334 28.2493 19.5001 28.3327 19.7501 28.3327C20.0001 28.3327 20.1667 28.2493 20.3334 28.0827C20.6667 27.7493 20.6667 27.2493 20.3334 26.916L19.6667 26.2493H27.5001C28.0001 26.2493 28.3334 25.916 28.3334 25.416V14.5827C28.3334 14.0827 28.0001 13.7493 27.5001 13.7493Z",
    fill: "#1B2430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.d8becd5f.svg";
export { ForwardRef as ReactComponent };